import React from "react";
import "./ReactivateModal.css"; // optional for styles

const ReactivateModal = ({
  isOpen,
  onConfirm,
  onCancel,
  userName = "",
  isDeactivateModalOpen = false,
  userEmail = "",
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="reactivate-modal">
        <h2>Reactivate User</h2>

        <p>
          {isDeactivateModalOpen ? (
            <span>{`User with email ${userEmail} already exists. Would you like to reactivate this account?`}</span>
          )
          :
          <span>
            {userName
              ? `Are you sure you want to reactivate ${userName}?`
              : "Are you sure you want to reactivate this user?"}
          </span>
}
        </p>

        <div className="modal-actions">
          <button className="reactivate_approve_btn" onClick={onConfirm}>
            Yes, I’m Sure
          </button>
          <button className="reactivate_reject_btn" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReactivateModal;
